import React from 'react'
import { Button, Menu } from 'antd'
import styles from './TopBar.module.scss'
import { SettingsIcon } from '../helpers/icons'

function PreferenceSettings({ onOpenSettingsDrawer, ...props }) {
	return (
		<Menu.Item style={{ borderBottom: 'none', marginRight: 0 }} {...props} className={styles.activeTab}>
			<Button
				icon={<SettingsIcon />}
				size='small'
				type={'text'}
				onClick={onOpenSettingsDrawer}
				className={styles.settingsIconContainer}
			/>
		</Menu.Item>
	)
}

export default PreferenceSettings
